import { render } from "./rechargeTable.vue?vue&type=template&id=2964d8bd&scoped=true&ts=true"
import script from "./rechargeTable.vue?vue&type=script&lang=ts"
export * from "./rechargeTable.vue?vue&type=script&lang=ts"

import "./rechargeTable.vue?vue&type=style&index=0&id=2964d8bd&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2964d8bd"]])

export default __exports__